import React  from "react";
import { useParams } from 'react-router-dom';
import ClientUserForm from "./components/ClientUserForm";
import Card from "components/card";

const EditClientUser = () => {

	const { clientId, userId } = useParams();

	return (
	    <div>
	    	<Card extra={"w-full h-full p-4"}>
				<div className="mt-5 grid h-full grid-cols-1 gap-4">
      				<ClientUserForm clientId={clientId} recordId={userId} mode="edit"/>
	      		</div>
	    	</Card>
	    </div>
    );
};

export default EditClientUser;